// RedirectingPage.js
import React from "react";
import API_URL from "../config/config";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { useState } from "react";
import { Box, Spinner, Text } from "grommet";
const RedirectingPage = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const redirectResponse = await axios.get(`${API_URL}/user/redirect`);

        const { url, user } = redirectResponse.data;

        if (user) login(user);

        navigate(`${url}`);

        // Log and navigate to the redirect URL

        setLoading(false);
      } catch (error) {
        console.error("Error redirecting:", error);
      }
    };

    fetchData(); // Call the fetchData function
  }, []);

  if (loading) {
    return (
      <Box fill align="center" justify="center">
        <Spinner size="large" />
        <Text>Please wait...</Text>
      </Box>
    );
  }
};

export default RedirectingPage;
